// extracted by mini-css-extract-plugin
export default {"modal":"EditorModal_modal__kl2SK","noScroll":"EditorModal_noScroll__zxNSM","close":"EditorModal_close__wJbYG","closeButton":"EditorModal_closeButton__T0FGI"};